import { combineReducers } from "@reduxjs/toolkit";
import { authSlice } from "../slices/AuthSlice";
import { memberListSlice } from "../slices/MemberListSlice";
import { teamTypeSlice } from "../slices/TeamTypeSlice";

const rootReducer = combineReducers({
  auth: authSlice.reducer,
  memberList: memberListSlice.reducer,
  teamTypes: teamTypeSlice.reducer,
});

export default rootReducer;
